module.exports = __webpack_public_path__ + "media/images/features/leaderboard-report-f1a58122d6015ba2e3fb596f87f21b21.png";